<template>
    <div class="col-12">
        <div class=" row text-center ml-5">
            <h3 class="ui inverted purple text"><strong>iSave Accounts</strong></h3>
            <p class="text-muted fw-light mt-4"> To initiate the iSave upgrade process, kindly click on the "Upgrade" button.</p>
        </div>

        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-9">

                <div class="row m-1">
                    <table class="ui celled purplescrolling long table">
                        <thead>
                        <tr>
                            <th>Account Type</th>
                            <th>Currency</th>
                            <th>Account Number</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="account in accounts" :key="account.id">
                            <td>{{ account.accountType }}</td>
                            <td>{{ account.currency }}</td>
                            <td>{{ account.maskedAccount }}</td>
                            <td class="right aligned">
                                <div class="ui small primary labeled icon button"
                                     @click="upgradeISave(account.uid)">
                                    <i class="book icon"></i> Upgrade
                                </div>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <div class="mt-4">
                    <button @click="back()" class="ui grey button fluid">Back</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {URLS} from "@/utils/constants";
import baseMethods from "@/utils/baseMethods";

export default {
    name: "iSaveList",
    data() {
        return {
            accounts: [],
        };
    },
    mounted() {
        this.getISaveAccounts();
    },
    methods: {
        upgradeISave(uid)
        {
            localStorage.setItem('account-uid', uid);
            this.$router.push('/account-opening/upgrade-iSave-terms-and-conditions')
        },
        getISaveAccounts() {
            this.get(URLS.accounts + '/iSave-accounts', false)
                .then(res => {
                    this.accounts = res.body;
                    console.log(this.accounts);
                    if (!res) return;
                    if (res.errors) return this.errors = res.errors;

                })
        },
        back() {
            this.$router.push("/account-opening/home");
        },
        ...baseMethods,
    },
}
</script>

<style scoped>

</style>